import React from 'react'
import * as formats from '../../constants/formats'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import { withStyles } from '@material-ui/core/styles'

const styles = {
	select: {
		width: '100%'
	}
}

const FormatSelector = ({ format, onChange, classes }) => (
	<Select value={format} onChange={onChange} className={classes.select}>
		<MenuItem value={formats.PDF}>PDF</MenuItem>
		<MenuItem value={formats.GEOJSON}>GeoJSON</MenuItem>
		<MenuItem value={formats.CSV}>CSV</MenuItem>
		<MenuItem value={formats.K_FIL}>K-fil</MenuItem>
	</Select>
)

export default withStyles(styles)(FormatSelector)



// WEBPACK FOOTER //
// ./src/components/Export/FormatSelector.js